<template>
  <div>
    <vue-headful
    title="Dashboard | Account Settings"
    description="Dashboard | Account Settings"
/>

<div v-if="loading" style="margin: 100px auto;">
  <center>
  <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
  <p class="lead">Loading...</p>
  </center>
</div>


    <div v-if="!loading" class="sc-kEYyzF grKTOC">
       <div class="sc-kAdXeD jwoEpG" style="padding: 0px 0px 30px 0px!important;">
          <div class="sc-bvTASY jPMoWD">
             <div class="sc-cFlXAS WflZx">
                <div style="position: relative;">

                <div>
                       <div class="card border-light shadow-soft" style="margin-bottom:20px;margin: 0 auto;padding: 10px;border-left: .0625rem solid rgba(243,247,250,.05); border-right: .0625rem solid rgba(243,247,250,.05); border-bottom: .0625rem solid rgba(243,247,250,.05); border-top: 0; border-radius: 0 0 .5rem .5rem;">
                          <div class="card-body p-4 p-lg-3">
                                  <div class="row">
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Full Name</label>
                                              <div class="input-group mb-2">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-user-alt"></i></span>
                                                  </div>
                                                  <input v-model="propsdata[0].name" name="name" class="form-control" placeholder="eg. John Doe" type="text">
                                              </div>
                                              <button v-if="!saving" @click="guardarname" style="width: 100%;" class="btn btn-primary animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>Save Name</button>
                                              <button v-if="saving" style="width: 100%;background:#04a677!important;border-color:#04a677!important;" class="btn btn-primary animate-up-2"><span class="mr-2"><i class="fas fa-check"></i></span>Saved</button>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Email Address</label>
                                              <div class="input-group mb-2">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                                                  </div>
                                                  <input :value="propsdata[0].email" name="name" class="form-control" type="text" disabled>
                                              </div>
                                          </div>
                                          <p>Use this email to log in to your Logo.app account and receive notifications.</p>
                                      </div>
                                      <hr>
                                      <div class="col-12">
                                         <div class="form-group">
                                            <label class="form-label text-dark">Password</label>
                                            <div v-if="propsdata[0].password !== 'submitted' || changepassword_toggle">
                                            <div class="input-group mb-2">
                                               <div class="input-group-prepend"><span class="input-group-text"><i class="fas fa-lock"></i></span></div>
                                               <input v-model="password" name="password" placeholder="Type your new password" type="password" class="form-control">
                                            </div>
                                            <span v-if="shortpassword" class="small" style="color:#ff0000;">Password must be at least 6 characters</span>
                                            <button v-if="!savingpassword" @click="guardarpassword" style="width: 100%;" class="btn btn-primary animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>Save Password</button>
                                            <button v-if="savingpassword" style="width: 100%;background:#04a677!important;border-color:#04a677!important;" class="btn btn-success animate-up-2"><span class="mr-2"><i class="fas fa-check"></i></span>Saving...</button>
                                            <button v-if="changepassword_toggle" @click="cancel_changepassword" style="width: 100%;background:#fa5352!important;border-color:#fa5352!important;margin-top:10px;" class="btn btn-danger animate-up-2"><span class="mr-2"><i class="fas fa-times"></i></span>Cancel</button>
                                            </div>
                                            <div v-else>
                                              <button @click="changepassword" style="width: 100%;" class="btn btn-primary animate-up-2"><span class="mr-2"><i class="fas fa-pen"></i></span>Change Password</button>
                                            </div>
                                         </div>
                                      </div>
                                  </div>
                          </div>
                      </div>

<div v-if="propsdata[0].paid !== 'yes'">
  <div class="card bg-white border-light shadow-soft" style="max-width: 800px; margin: 20px auto 20px auto; padding: 10px;">
    <div class="card-body p-4 p-lg-3">
      <div class="row">
        <div class="col-12 col-md-6 mb-lg-0">
          <h3 class="mb-3">Free Account</h3>
          <p class="text-muted mb-4">You are on the free plan. You can preview and generate logos with watermark. Upgrade to download all your logos, create unlimited amounts and download high resolution files.</p>
        </div>
        <div class="col-12 col-md-6 d-flex align-items-center justify-content-md-end">
          <a :href="'/payment/sub/'+propsdata[0].unique_id" class="btn btn-md btn-pricing-plan animate-up-2" style="color: #ffffff; background-color: #0949b3; border-color: rgb(255, 255, 255);"><svg width="24" height="24" fill="#ffffff" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg>
                Upgrade Now</a>
        </div>
      </div>
    </div>
  </div>
</div>

                  </div>


             </div>
          </div>
       </div>
    </div>

  </div>
  </div>

</template>

  <script>
  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        changepassword_toggle: false,
        password: '',
        savingpassword: false,
        shortpassword: false,
        saving: false,
        cancelling: false,
        canceled: false,
        cancellation_error: false
      };
    },
    methods: {
      guardarname(){
        this.saving = true;
        axios.post('/dashboard/enviar-account.php', {
          name: this.propsdata[0].name
          })
          .then(response => {
            this.saving = false;
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      guardarpassword(){
        this.savingpassword = true;
        axios.post('/dashboard/edit-password.php', {
          password: this.password
          })
          .then(response => {
            if(response.data == 'Password must be at least 6 characters'){
              this.shortpassword = true;
            }
            else{
              this.shortpassword = false;
              this.propsdata[0].password = 'submitted';
              this.password = '';
              this.changepassword_toggle = false;
            }
            this.savingpassword = false;
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      changepassword(){
        this.changepassword_toggle = true;
      },
      cancel_changepassword(){
        this.changepassword_toggle = false;
      },
    },
    mounted() {
      this.loading = false;
    }
  };
  </script>



// WEBPACK FOOTER //
// src/account.vue